<script lang="ts">
  interface Props {
    size?: number;
    [key: string]: any;
  }

  let { size = 16, ...rest }: Props = $props();
</script>

<svg
  width={size}
  height={size}
  viewBox="0 0 16 16"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
  {...rest}
>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M15 8A7 7 0 111 8a7 7 0 0114 0zm-3.52-1.924a.75.75 0 00-.96-1.152C8.629 6.5 7.495 8.437 6.887 9.742a44.84 44.84 0 01-.123.262 46.923 46.923 0 01-.147-.183l-1.031-1.29a.75.75 0 10-1.172.938l1.032 1.29.017.02c.151.19.29.363.412.493.109.118.307.318.592.403l.212-.72-.212.72c.34.1.674.06.98-.118.264-.152.411-.407.489-.546.09-.162.19-.375.3-.611l.01-.024c.555-1.19 1.572-2.915 3.234-4.3z"
    fill="currentColor"
  />
</svg>
